module.exports = __webpack_public_path__ + "img/PropertyTypes.65ed47fc.svg";